/**
 * @file 路由入口
 */
import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/home';
import Classes from '@/components/classes';
import ClassesDetail from '@/components/classes-detail';
import MyOrder from '@/components/my-order';
import MyCenter from '@/components/my-center';
import Pregnancy from '@/components/pregnancy';
import Postpartum from '@/components/postpartum';
import AuthorDetail from '@/components/author-detail';

import PublicOrder from '@/components/public-order';
import PrivateOrder from '@/components/private-order';
import OrderDetail from '@/components/order-detail';
import PointsDetail from '@/components/points-detail';
import MyUserinfo from '@/components/my-userinfo';
import Login from '@/components/login';

// import PregnancyPlan from '@/components/pregnancy-plan';
// import PostpartumPlan from '@/components/postpartum-plan';
import PlanInfo from '@/components/plan-info';

// 教师端
import TeacherHome from '@/components/teacher/home';
import TeacherCenter from '@/components/teacher/center';
import TeacherCommonClasses from '@/components/teacher/common-classes';
import TeacherPrivateClasses from '@/components/teacher/private-classes';
import TeacherOrderDetail from '@/components/teacher/order-detail';

Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};

export default new Router({
    // mode: 'history',
    routes: [
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            path: '/home',
            name: 'home',
            component: Home,
            meta: {requireAuth: true}
        },
        {
            path: '/classes',
            name: 'classes',
            component: Classes,
            meta: {requireAuth: true},
            children: [{
                path: '/postpartum',
                name: 'postpartum',
                component: Postpartum,
                meta: {requireAuth: true}
            }, {
                path: '/pregnancy',
                name: 'pregnancy',
                component: Pregnancy,
                meta: {requireAuth: true}

            }]
        },
        {
            path: '/classes-detail/:id/:refer_name?',
            name: 'classes-detail',
            meta: {requireAuth: true},
            component: ClassesDetail
        },
        {
            path: '/author-detail/:id/:refer_name?/:classId?',
            name: 'author-detail',
            meta: {requireAuth: true},
            component: AuthorDetail
        },
        {
            path: '/my-order',
            name: 'my-order',
            meta: {requireAuth: true},
            component: MyOrder,
            children: [{
                path: '/public-order',
                name: 'public-order',
                meta: {requireAuth: true},
                component: PublicOrder
            }, {
                path: '/private-order',
                name: 'private-order',
                meta: {requireAuth: true},
                component: PrivateOrder,
            }]
        },
        {
            path: '/order-detail/:id',
            name: 'order-detail',
            meta: {requireAuth: true},
            component: OrderDetail
        },
        {
            path: '/my-center',
            name: 'my-center',
            meta: {requireAuth: true},
            component: MyCenter
        },
        {
            path: '/points-detail',
            name: 'points-detail',
            meta: {requireAuth: true},
            component: PointsDetail
        },
        {
            path: '/my-userinfo',
            name: 'my-userinfo',
            meta: {requireAuth: true},
            component: MyUserinfo
        },
        // {
        //     path: '/pregnancy-plan/:refer_name?',
        //     name: 'pregnancy-plan',
        //     meta: {requireAuth: true},
        //     component: PregnancyPlan
        // },
        // {
        //     path: '/postpartum-plan/:refer_name?',
        //     name: 'postpartum-plan',
        //     meta: {requireAuth: true},
        //     component: PostpartumPlan
        // },
        {
            path: '/plan-info/:refer_name?',
            name: 'plan-info',
            component: PlanInfo
        },
        {
            path: '/',
            redirect: '/home'
        },
        // 教师端
        {
            path: '/teacher-home',
            name: 'teacher-home',
            component: TeacherHome
        },
        {
            path: '/teacher-center',
            name: 'teacher-center',
            component: TeacherCenter
        },
        {
            path: '/teacher-common-classes',
            name: 'teacher-common-classes',
            component: TeacherCommonClasses
        },
        {
            path: '/teacher-private-classes',
            name: 'teacher-private-classes',
            component: TeacherPrivateClasses
        },
        {
            path: '/teacher-order-detail/:id?',
            name: 'teacher-order-detail',
            component: TeacherOrderDetail
        }
    ],
    scrollBehavior (to, from, savedPosition) {
        return {x: 0, y: 0};
    }
});






// WEBPACK FOOTER //
// ./src/router/index.js